import { connect } from "react-redux";
import WorkArea from "../../components/Engineering/WorkArea";
import {
  applyWorkArea,
  closeWorkArea,
  resetWorkArea
} from "../../actions/engineering";

const mapDispatchToProps = dispatch => ({
  submit: (node, inputs) => dispatch(applyWorkArea(node, inputs)),
  reset: node => dispatch(resetWorkArea(node)),
  close: node => dispatch(closeWorkArea(node))
});

export default connect(null, mapDispatchToProps)(WorkArea);
